import { ISelectLabel } from "@ds/ds-snam/dist/models/select";

/** Utility to manually select an option ad deselect all others on DsSelect, as it doesn't doo that by itself as it was doing before in legacy version of Ds Library */
export const dsSelectHandler = (options:ISelectLabel[], selection:ISelectLabel)=>{
    options.forEach((option:ISelectLabel)=>{
        option.selected = option.id === selection.id;
    })
}

export const dsDeselectHandler = (options: ISelectLabel[]) => {
    options.forEach((option: ISelectLabel) => {
        option.selected = false;
    });
}

export const dsPreSelectHandler = (options:ISelectLabel[],value:string)=>{
    options.forEach((option:ISelectLabel)=>{
        option.selected = option.value === value;
    })
}

export const getTableCellsHeaderSimple = (_text:string,_columnId:string,_width:string,_textAlign:"left" | "right" | "center",_hasSortingFilter?: boolean) => {
    const cell: any = {
        text: _text,
        columnId: _columnId,
        columnWidth: _width,
        textAlign: _textAlign,
    };
    if(_hasSortingFilter!==undefined){
        cell.hasSortingFilter = _hasSortingFilter;
    }
    return cell;
}

export function getDSTableSharedElements(tableHeight?: number) {
    return {
        ...(tableHeight !== undefined ? { tableHeight } : {}), // Se tableHeight è definito, lo include
        panelActionMobileLabel: "Azioni",
        labelButtonExpandMobile: "Espandi",
        labelButtonReduceMobile: "Riduci",
        hasMobileFilter: true,
        buttonShowMoreMobile: "Mostri di più",
        tableWidthPercentage: true,
        tableAriaLabel: "table aria label",
    };
}

export function getDSTableShaderElementsForFilterColumn(_text:string,_columnId:string,_width:string,_leftButtonLabel:string,_rightButtonLabel:string,_searchBoxPlaceHolder:string) {
    return {
        text: _text,
        columnId: _columnId,
        columnWidth: _width,
        textAlign: "left" as "left",
        hasSearchBox: true,
        leftButtonLabel: _leftButtonLabel,
        rightButtonLabel: _rightButtonLabel,
        searchBoxPlaceHolder: _searchBoxPlaceHolder,

        searchBoxVariant: "text-variant" as "text-variant",
        ariaComboKeyCloseWriteMode:
        "For enter in  write mode in the select search bar press Shift+G",
        ariaComboKeyOpenWriteMode:
            "For enter in  write mode in the select search bar press Shift+H",
        LabelMultiOptionSelected: "Selezionate",
        LabelSingleOptionSelected: "Selezionata",        
       
    };
}